<template>
  <div
    class="animate-pulse bg-white rounded-lg flex flex-col justify-between items-start shadow-md gap-4 flex-1 border-color-blue p-3 custom-min-height"
  >
    <span class="h-6 bg-grey-light rounded w-3/4"></span>
    <span class="h-6 bg-grey-light rounded w-1/2"></span>
    <span class="h-4 bg-grey-light rounded w-1/4"></span>
  </div>
</template>

<script>
export default {
  name: 'SkeletonCard',
};
</script>

<style scoped>
.custom-min-height {
  min-height: 124px;
}
</style>
